// organizations#credits — buying AI credits (React + Stripe).
import { registerPage } from "../first"
import { mountCreditsApp } from "../organization_credits"

export const OrganizationsCreditsPage = {
  onDomReady(): void {
    mountCreditsApp()
  },
}

registerPage("OrganizationsCreditsPage", OrganizationsCreditsPage)
